import type { BaseUrl } from '@atlassian/jira-shared-types';

export const getGraphQlUrl = (baseUrl: BaseUrl): string => `${baseUrl}/rest/graphql/1/`;
